// Neu (SPEC 03 §7.3) — dieselbe Regel wie SPEC 02 §1.6 (Schutz vor offener Umleitung).
const ERLAUBT = /^\/(r|d|b|m|x|a|t|q|v)\/[^\s]*$/;
export function sicheresZiel(next: string | null): string {
  if (!next) return "/";
  return next === "/" || ERLAUBT.test(next) ? next : "/";
}
